// extracted by mini-css-extract-plugin
export default {"relatedFaq":"RelatedFaq_relatedFaq__CoNG8"};